var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D80027"
    },
    d: "M367.304,25.402C333.648,9.128,295.89,0,256,0s-77.648,9.128-111.304,25.402L122.435,256 l22.261,230.598C178.352,502.872,216.11,512,256,512s77.648-9.128,111.304-25.402L389.565,256L367.304,25.402z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M144.696,25.411C59.066,66.818,0,154.507,0,256s59.066,189.182,144.696,230.589V25.411z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#496E2D"
    },
    d: "M367.304,25.411v461.178C452.934,445.182,512,357.493,512,256S452.934,66.818,367.304,25.411z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M256,166.957c-49.178,0-89.043,39.866-89.043,89.043s39.866,89.043,89.043,89.043 s89.043-39.866,89.043-89.043S305.178,166.957,256,166.957z M256,311.652c-30.736,0-55.652-24.917-55.652-55.652 s24.917-55.652,55.652-55.652s55.652,24.917,55.652,55.652S286.736,311.652,256,311.652z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDA44"
    },
    d: "M256,222.609c-12.295,0-22.261,9.966-22.261,22.261v33.391h44.522V244.87 C278.261,232.575,268.295,222.609,256,222.609z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAf);
export default __webpack_public_path__ + "static/media/af.1bce6d79685eeb2e823a250bab5ac56f.svg";
export { ForwardRef as ReactComponent };